<script>
import { mapActions } from "vuex";

export default {
  name: "resetPasswordSection",
  data() {
    return {
      newPassword: "",
      viewNewPassword: "",
      confirmPassword: "",
      viewConfirmPassword: "",
      haveSubmit: false,
      warn: false,
      disable: true,
      tenant: window.location.hostname
        .replace("www.", "")
        .split(".")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    console.log(that.$route.query.sessionId);
    console.log(that.$route.query.email);
  },
  methods: {
    ...mapActions("login", ["update"]),
    handleInput() {
      var that = this;
      that.newPassword = that.newPassword.replace(/\s+/g, "");
      that.confirmPassword = that.confirmPassword.replace(/\s+/g, "");
      that.warn = false;
      if (that.newPassword.length > 7 && that.confirmPassword.length > 7) {
        that.disable = false;
      } else {
        that.disable = true;
      }
    },
    saveNewPassword() {
      console.log("New Password Saved");
      var that = this;
      if (
        that.newPassword !== that.confirmPassword ||
        that.newPassword.length < 7
      ) {
        that.warn = true;
        return;
      }
      that.$box.loadings();
      that.update({
        params: {
          email: decodeURI(that.$route.query.email),
          password: that.newPassword,
          sessionId: decodeURI(that.$route.query.sessionId)
        },
        callback: that.callback
      });
    },
    callback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        that.haveSubmit = true;
        that.$box.alert("", "Your password changed successfully", "success");
        that.$router.replace("/password/success");
      } else {
        if (res.data.code == 50000) {
          // timeout
          that.$router.replace("/password/expired");
          that.$box.alert("", res.data.message, "warn");
        } else {
          that.$box.alert("", res.data.message, "error");
        }
      }
    },
    clean(txt) {
      var that = this;
      if (txt == "newPassword") {
        that.newPassword = "";
      } else if (txt == "confirmPassword") {
        that.confirmPassword = "";
      }
      that.warn = false;
      that.disable = true;
    },
    login() {
      this.$router.replace("/newlogin");
    }
  }
};
</script>

<template>
  <el-row style="padding: 50px 16px; background-color: #2D2D2D">
    <el-col :span="24">
      <img
        class="background-image"
        loading="lazy"
        src="../../assets/AgentLoginBackground.jpg"
      />
      <div class="backdrop">
        <el-row>
          <el-col :span="24">
            <span class="sign-in-lbl">Reset Password</span>
          </el-col>
        </el-row>
        <el-row style="width: 100%; margin-top: 16px">
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <el-input
              v-model="newPassword"
              placeholder="New Password"
              v-bind:type="viewNewPassword ? 'text' : 'password'"
            >
              <template slot="prepend"><i class="el-icon-lock"/></template>
              <template v-if="!viewNewPassword" slot="append"
                ><i
                  class="el-icon-view"
                  @click="viewNewPassword = !viewNewPassword"
              /></template>
              <template v-if="viewNewPassword" slot="append"
                ><i
                  ><img
                    class="icon-hide"
                    src="../../assets/el-icon-hide.svg"
                    @click="viewNewPassword = !viewNewPassword"/></i
              ></template>
            </el-input>
          </el-col>
        </el-row>
        <el-row style="width: 100%">
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <el-input
              v-model="confirmPassword"
              placeholder="Confirm New Password"
              v-bind:type="viewConfirmPassword ? 'text' : 'password'"
              @keyup.enter.native="saveNewPassword"
            >
              <template slot="prepend"><i class="el-icon-lock"/></template>
              <template v-if="!viewConfirmPassword" slot="append"
                ><i
                  class="el-icon-view"
                  @click="viewConfirmPassword = !viewConfirmPassword"
              /></template>
              <template v-if="viewConfirmPassword" slot="append"
                ><i
                  ><img
                    class="icon-hide"
                    src="../../assets/el-icon-hide.svg"
                    @click="viewConfirmPassword = !viewConfirmPassword"/></i
              ></template>
            </el-input>
          </el-col>
        </el-row>
        <el-row style="width: 100%">
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <el-button class="btn-primary" @click="saveNewPassword"
              >Save</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.sign-in-lbl {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
  align-self: stretch;
}

.btn-primary {
  color: #ffffff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  padding: 14px 60px;
  font: 600 20px DINosaur-a, sans-serif;
}

.btn-underline {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: diNosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  //border-bottom: 1px solid #fff;
}

.sign-up-lbl {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: 125%;
}

.font400 {
  font-weight: 400;
}

.font600 {
  font-weight: 600;
}

.el-divider__text {
  background-color: #0d0d0d;
  //opacity: 0.7;
}

.effect-fading {
  display: flex;
  padding: 20px 16px 30px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  background: #2d2d2d;
}

.backdrop {
  position: relative;
  padding: 20px 16px 30px 16px;
  background-color: rgba(0, 0, 0, 0.8);
}

.background-image {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.5;
  //z-index: -34;
}

.forgotPasswordSpan {
  padding-bottom: 10px;
}

.forgotPasswordInput {
  padding-top: 10px;
}

.forgotPasswordBtn {
  color: #ffffff;
  height: 54px;
  justify-content: center;
  white-space: normal;
  align-items: center;
  border-radius: 5px;
  border: 3px solid #003333;
  background-color: #003333;
  width: 260px;
  font: 600 20px DINosaur-a, sans-serif;
}

.el-dialog--center /deep/ .el-dialog__header {
  color: #101010;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a, sans-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
}

.para-style {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/components/reset/resetPasswordSection.vue